import VueRouter from 'vue-router'
import guards from '@/views/routers/guards'
import comum from '@/views/routers/routes/comum'
import ata from '@/views/routers/routes/ata/ata'
import configuracao from '@/views/routers/routes/configuracao'
import pedido from '@/views/routers/routes/pedido/pedido'
import adesao from '@/views/routers/routes/adesao/adesao'
import relatorios from '@/views/routers/routes/relatorios'
import sobre from '@/views/routers/routes/sobre'

const router = new VueRouter({
	routes: [...comum, ...ata, ...relatorios ,...configuracao, ...pedido, ...adesao, ...sobre],
})

router.beforeEach((to, from, next) => guards.condicoes(to, from, next))

export default router
